<template>
  <!-- Tela de Registro -->
  <v-container v-if="!playerRegistered" class="text-center " :style="styleBackground">
    <v-row> 
      <v-col class="cor-branca">
    <h1>Bem-vindo ao Quiz</h1>
    <p><strong>QUIZ:</strong> {{ categoryName }}</p>
    <v-text-field
      v-model="playerName"
      label="Digite seu Nome ou Apelido"
      outlined
      class="mb-4"
    ></v-text-field>
    <v-btn color="primary" @click="registerPlayer">Entrar</v-btn>
  </v-col>
    </v-row>
  </v-container>

  <!-- Tela de Quiz Liberado -->
  <v-container v-else-if="quizStarted" class="text-center">
    <h1>Quiz Liberado!</h1>
    <QuizGameComponent
      :playerName="playerName"
      :categoryName="categoryName"
      :sessionKey="sessionKey"   

      :key="sessionKey"
    />
  </v-container>

  <!-- Tela de Registro Confirmado -->
  <v-container v-else class="text-center">
    <h1>Registro Confirmado</h1>
    <p><strong>TREINAMENTO:</strong> {{ trainingName }}</p>
    <p><strong>QUIZ:</strong> {{ categoryName }}</p>
    <p><strong>NOME/APELIDO:</strong> {{ playerName }}</p>
    <p><strong>Data e Hora:</strong> {{ currentDate }}</p>
    <h1>AGUARDE A LIBERAÇÃO </h1>
    <h2>NÃO SAIA DA TELA</h2>
    
  </v-container>

  <!-- Modal de Erro/Sucesso -->
  <ModalMessage
    :dialog="showModal"
    @update:dialog="showModal = $event"
    :title="modalTitle"
    :message="modalMessage"
    :type="modalType"
  />
</template>

<script>
import ModalMessage from "./ModalMessage.vue";
import QuizGameComponent from "./QuizGameComponent.vue";
import { loadPrivateKey, registerPlayer, checkQuizStatus } from "../services/googleSheetsSevice";


export default {
  components: { ModalMessage, QuizGameComponent },
  props: ["categoryId"],
  data() {
    return {
      backgroundImage: "/img/back/1.jpg",

      currentDate: "",
      playerName: "",
      playerRegistered: false,
      trainingName: "", // Nome da Aula/Treinamento (pode ser definido se necessário)
      categoryName: "", // Categoria correta
      sessionKey: "",
      maxParticipants: 0,
      quizStarted: false,
      intervalId: null,

      // Modal
      showModal: false,
      modalTitle: "",
      modalMessage: "",
      modalType: "success",
    };
  },
  async created() {
    await loadPrivateKey();
    const urlParams = new URLSearchParams(window.location.search);
    this.sessionKey = urlParams.get("key");
    this.maxParticipants = parseInt(urlParams.get("limit")) || 0;
    this.categoryName = urlParams.get("category") || "Categoria Não Informada";
  },
  computed:{
    styleBackground() {
            return {
                background: `url(${this.backgroundImage})`,
                backgroundSize: "cover",
                minHeight: "100vh",
            };
        },
  },
  methods: {
    showAlertModal(title, message, type = "success") {
      this.showModal = true;
      this.modalTitle = title;
      this.modalMessage = message;
      this.modalType = type;
    },
    async registerPlayer() {
      if (!this.playerName.trim()) {
        this.showAlertModal("Erro", "Por favor, digite seu nome ou apelido.", "error");
        return;
      }
      try {
        // Registra o jogador utilizando a função do serviço;
        // A função retorna a data/hora do registro.
        const date = await registerPlayer(this.playerName, this.categoryName, this.sessionKey, this.maxParticipants);
        this.currentDate = date;
        this.playerRegistered = true;
        this.showAlertModal("Sucesso", "Você foi registrado com sucesso!", "success");

        // Verifica periodicamente o status do quiz
        this.intervalId = setInterval(async () => {
          const status = await checkQuizStatus(this.sessionKey);
          if (status) {
            clearInterval(this.intervalId);
            this.quizStarted = true;
          }
        }, 5000);
      } catch (error) {
        this.showAlertModal("Erro", error.message, "error");
      }
    },
  },
};
</script>

<style scoped>

.cor-branca {
    background-color: rgba(255, 255, 255, 0.8);
    text-align: center;
}
::v-deep th.custom-header {
  text-align: center !important;
  font-weight: bold !important;
}

/* Se houver um container interno (como um <div>) dentro do <th> */
::v-deep th.custom-header > div {
  display: flex !important;
  justify-content: center !important;
  width: 100%;
}
</style>
